import { render, staticRenderFns } from "./TrendingProductSlidegroup.vue?vue&type=template&id=4f5a6d98"
import script from "./TrendingProductSlidegroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingProductSlidegroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CreatorShopTrendingProductTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/trending-product/TrendingProductTile.vue').default,CSlideItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSlideGroup/CSlideItem.vue').default,CLtkSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkSlideGroup/CLtkSlideGroup.vue').default})
